<script setup lang="ts">
import { toRefs } from 'vue';
import { DialogModal, type DialogModalProps } from '@common';
import { HtmlContentContainer } from '@shared';

const props = defineProps<DialogModalProps>();
const { config } = toRefs(props);

const htmlConfig = { key: 'maximap.heightmap.apiError.info' };
</script>

<template>
  <dialog-modal :config="config">
    <template #default>
      <html-content-container :config="htmlConfig"></html-content-container>
    </template>
    <template #actions="{ close }">
      <div class="d-flex ga-3">
        <v-btn
          variant="elevated"
          class="px-6"
          @click="close()">
          {{ $t('button.okay') }}
        </v-btn>
      </div>
    </template>
  </dialog-modal>
</template>
